// extracted by mini-css-extract-plugin
module.exports = {"backLink":"ForgotPassword_backLink__YC_i-"};